import { render, staticRenderFns } from "./PanelFiche.vue?vue&type=template&id=2246705c&scoped=true&"
import script from "./PanelFiche.vue?vue&type=script&lang=js&"
export * from "./PanelFiche.vue?vue&type=script&lang=js&"
import style0 from "./PanelFiche.vue?vue&type=style&index=0&id=2246705c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2246705c",
  null
  
)

export default component.exports